import React, {useEffect, useState} from "react";
import {systemService, userServices} from "../../services";
import {Button, Col, notification, Row, Spin} from "antd";
import DividerBlock from "../divider-block";
import InputField from "../input-field";
import {ADVANCED_ACCOUNT_PROTECTION, COMPANY_DIRECTOR_PERMISSION} from "../../helpers/user_permission.helper";
import PhoneField from "../phone-field";
import i18n from "../../i18n";

export default function UserProfileEditForm() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const [passwordFormData, setPasswordFormData] = useState({
    oldPassword: '',
    newPassword: '',
    newPasswordRepeat: '',
    code: '',
    codeToken: '',
  });

  const [loginFormData, setLoginFormData] = useState({
    oldLogin: '',
    oldLoginCountryID: null,
    oldLoginCode: '',
    oldLoginCodeToken: '',

    newLogin: '',
    newLoginCountryID: null,
    newLoginCode: '',
    newLoginCodeToken: '',
  });
  const [loadingLoginForm, setLoadingLoginForm] = useState({
    oldLoginCodeIsLoading: false,
    newLoginCodeIsLoading: false,
  });

  const [name, setName] = useState('');
    const [email, setEmail] = useState('');

  const [fieldsErrors, setFieldsErrors] = useState({});

  useEffect(() => {
    setUser(userServices.getUser());
  }, []);

  useEffect(() => {
    if (user) {
      setLoading(false);
      setName(user.info.fio);
            setEmail(user.info.email);
      setLoginFormData({
        ...loginFormData,
        oldLogin: user.info.login,
        oldLoginCountryID: user.info.country.id,
      });
    }
  }, [user])

  const getFieldErrors = fieldName => {
    return typeof fieldsErrors[fieldName] !== "undefined"
      ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
        return fieldErrors + "; " + error;
      })
      : null;
  };

  const handleRequestCodOnChangePassword = () => {
    userServices.getVerifyCode()
      .then(resp => {
        setPasswordFormData({
          ...passwordFormData,
          codeToken: resp.token
        });
      })
      .catch(err => {
        notification.error({
          message: i18n.t('components.notification.titles.getVerifyCode.error'),
          description: err,
        });
      });
  };

  const handleRequestCode = (phone, countryID, setToken) => {
    setLoadingLoginForm({
      ...loadingLoginForm,
      oldLoginCodeIsLoading: true,
      newLoginCodeIsLoading: true,
    });
    setFieldsErrors([]);
    systemService.getPhoneCode(phone, countryID)
      .then((resp) => {
        if (resp.status === 'error') {
          setFieldsErrors(resp.errors);
          notification.error({
            message: i18n.t('components.notification.titles.getVerifyCode.error'),
            description: i18n.t('components.notification.text.getVerifyCode.error'),
          });
        } else {
          notification.success({
            message: i18n.t('components.notification.titles.getVerifyCode.success'),
            description: i18n.t('components.notification.text.getVerifyCode.success') + ' ' + phone,
          });
          setToken(resp[0].token);
        }
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.getVerifyCode.success'),
          description: err,
        });
      })
      .finally(() => {
        setLoadingLoginForm({
          ...loadingLoginForm,
          oldLoginCodeIsLoading: false,
          newLoginCodeIsLoading: false,
        });
      })
  };

  const handleChangePassword = () => {
    setLoading(true);
    userServices.changePassword(passwordFormData)
      .then(resp => {
        setFieldsErrors([]);
        if (resp.status === 'success') {
          notification.success({
            message: i18n.t('components.notification.titles.changePassword'),
            description: resp.message,
          });

          setPasswordFormData({
            ...passwordFormData,
            oldPassword: '',
            newPassword: '',
            newPasswordRepeat: '',
            code: '',
            codeToken: '',
          })
        } else if (resp.status === 'error') {
          setFieldsErrors(resp.errors);
        }
      })
      .catch(err => {
        notification.error({
          message: i18n.t('components.notification.titles.changePassword'),
          description: err,
        });
      })
      .finally(() => setLoading(false));
  };

    const handleChangeProfile = () => {
    setLoading(true);
        userServices.changeProfile(name, email)
      .then(resp => {
        setFieldsErrors([]);
        if (resp.status === 'success') {
          notification.success({
            message: i18n.t('components.notification.titles.changeName'),
            description: resp.message,
          });
        } else if (resp.status === 'error') {
          setFieldsErrors(resp.errors);
        }
      })
      .catch(err => {
        notification.error({
          message: i18n.t('components.notification.titles.changeName'),
          description: err,
        });
      })
      .finally(() => setLoading(false));
  };

  const handleChangeLogin = () => {
    setLoading(true);
    setFieldsErrors([]);
    userServices.changeLogin(loginFormData)
      .then((resp) => {
        if (resp.status === 'error') {
          setFieldsErrors(resp.errors);
        } else {
          notification.success({
            message: i18n.t('components.notification.titles.getVerifyCode.success'),
            description: resp.message,
          });

        }
      })
      .catch()
      .finally(() => {
        setLoading(false);
      });
  };

  let buttonStyle = {
    width: '100%',
    height: '40px',
    background: '#1CAA53',
    borderRadius: '4px',
    float: 'left',
    borderColor: "#1CAA53"
  };
  let requestCodeButtonStyle = {
    width: '100%',
    height: '40px',
    background: '#2b3f63',
    borderRadius: '4px',
    float: 'left',
    borderColor: "#2b3f63",
    marginTop: '33px'
  };
  return (
    <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
      <h1 className="content-header">{i18n.t('components.userProfileEditForm.title')}</h1>
      <DividerBlock label={i18n.t('components.userProfileEditForm.divider.password')}/>
      <Row gutter={[16, 24]}>
        <Col lg={6}>
          <InputField
            name="oldPassword"
            label={i18n.t('components.userProfileEditForm.form.oldPassword.title')}
            value={passwordFormData.oldPassword}
            getFieldErrors={getFieldErrors}
            type="password"
            setValue={(value) => {
              setPasswordFormData({...passwordFormData, oldPassword: value})
            }}
          />
        </Col>
      </Row>
      <Row gutter={[16, 24]}>
        <Col lg={6}>
          <InputField
            name="newPassword"
            label={i18n.t('components.userProfileEditForm.form.newPassword.title')}
            value={passwordFormData.newPassword}
            getFieldErrors={getFieldErrors}
            type="password"
            setValue={(value) => {
              setPasswordFormData({...passwordFormData, newPassword: value})
            }}
          />
        </Col>
        <Col lg={6}>
          <InputField
            name="newPasswordRepeat"
            label={i18n.t('components.userProfileEditForm.form.newPasswordRepeat.title')}
            value={passwordFormData.newPasswordRepeat}
            getFieldErrors={getFieldErrors}
            type="password"
            setValue={(value) => {
              setPasswordFormData({...passwordFormData, newPasswordRepeat: value})
            }}
          />
        </Col>
      </Row>
      {(user && user.isAccessTo(ADVANCED_ACCOUNT_PROTECTION)) ? (
        <Row gutter={[16, 24]}>
          <Col lg={4}>
            <InputField
              name="code"
              label={i18n.t('components.userProfileEditForm.form.code.title')}
              getFieldErrors={getFieldErrors}
              value={passwordFormData.code}
              setValue={(value) => {
                setPasswordFormData({...passwordFormData, code: value})
              }}
            />
          </Col>
          <Col lg={6}>
            <Button
              type="primary"
              htmlType="button"
              onClick={handleRequestCodOnChangePassword}
              size="small"
              style={requestCodeButtonStyle}
            >
              {i18n.t('components.userProfileEditForm.buttons.getCode')}
            </Button>
          </Col>
        </Row>
      ) : null}
      <Row gutter={[16, 24]}>
        <Col lg={6}>
          <Button
            type="primary"
            htmlType="button"
            onClick={handleChangePassword}
            size="small"
            style={buttonStyle}
          >
            {i18n.t('components.userProfileEditForm.buttons.passwordEdit')}
          </Button>
        </Col>
      </Row>

      {(user && user.isAccessTo(COMPANY_DIRECTOR_PERMISSION)) ? (
        <>
          <DividerBlock label={i18n.t('components.userProfileEditForm.divider.name')}/>
          <Row gutter={[16, 24]}>
                        <Col lg={12}>
              <InputField
                name="name"
                label={i18n.t('components.userProfileEditForm.form.name.title')}
                getFieldErrors={getFieldErrors}
                value={name}
                setValue={setName}
              />
                        </Col>
                        <Col lg={12}>
                            <InputField
                                name="email"
                                label="Email"
                                getFieldErrors={getFieldErrors}
                                value={email}
                                setValue={setEmail}
                            />
            </Col>
          </Row>
          <Row gutter={[16, 24]}>
            <Col lg={6}>
              <Button
                type="primary"
                htmlType="button"
                                onClick={handleChangeProfile}
                size="small"
                style={buttonStyle}
              >
                {i18n.t('components.userProfileEditForm.buttons.nameEdit')}
              </Button>
            </Col>
          </Row>

          <DividerBlock label={i18n.t('components.userProfileEditForm.divider.login')}/>
          <Row gutter={[16, 24]}>
            <Col lg={12}>
              <PhoneField
                getErrors={getFieldErrors}
                countryFieldName="oldLoginCountryID"
                countryFieldWidth="104px"
                phoneFieldName="oldLogin"
                phoneFieldWidth="200px"
                isDisabled={true}
                title={i18n.t('components.userProfileEditForm.form.oldLoginCountryID.title')}
                selectedCountryID={loginFormData.oldLoginCountryID}
                onChangeCountry={(value) => {
                  setLoginFormData({
                    ...loginFormData,
                    oldLoginCountryID: value
                  });
                }}
                phoneNumber={loginFormData.oldLogin}
                onChangePhone={(e) => {
                  setLoginFormData({
                    ...loginFormData,
                    oldLogin: e.target.value
                  });
                }}
              />
            </Col>
            <Col lg={3}>
              <InputField
                name="oldLoginCode"
                label={i18n.t('components.userProfileEditForm.form.oldLoginCode.title')}
                getFieldErrors={getFieldErrors}
                value={loginFormData.oldLoginCode}
                setValue={(value) => {
                  setLoginFormData({...loginFormData, oldLoginCode: value})
                }}
              />
            </Col>
            <Col lg={9}>
              <Button
                type="primary"
                htmlType="button"
                disabled={loadingLoginForm.oldLoginCodeIsLoading}
                onClick={() => {
                  handleRequestCode(
                    loginFormData.oldLogin,
                    loginFormData.oldLoginCountryID,
                    (token) => {
                      setLoginFormData({
                        ...loginFormData,
                        oldLoginCodeToken: token,
                      });
                    }
                  )
                }}
                size="small"
                style={requestCodeButtonStyle}
              >
                {i18n.t('components.userProfileEditForm.buttons.getCode')}
              </Button>
            </Col>
          </Row>
          <Row gutter={[16, 24]}>
            <Col lg={12}>
              <PhoneField
                getErrors={getFieldErrors}
                countryFieldName="newLoginCountryID"
                countryFieldWidth="104px"
                phoneFieldName="newLogin"
                phoneFieldWidth="200px"
                title={i18n.t('components.userProfileEditForm.form.newLoginCountryID.title')}
                selectedCountryID={loginFormData.newLoginCountryID}
                onChangeCountry={(value) => {
                  setLoginFormData({
                    ...loginFormData,
                    newLoginCountryID: value
                  });
                }}
                phoneNumber={loginFormData.newLogin}
                onChangePhone={(e) => {
                  setLoginFormData({
                    ...loginFormData,
                    newLogin: e.target.value
                  });
                }}
              />
            </Col>
            <Col lg={3}>
              <InputField
                name="newLoginCode"
                label={i18n.t('components.userProfileEditForm.form.newLoginCode.title')}
                getFieldErrors={getFieldErrors}
                value={loginFormData.newLoginCode}
                setValue={(value) => {
                  setLoginFormData({...loginFormData, newLoginCode: value})
                }}
              />
            </Col>
            <Col lg={9}>
              <Button
                type="primary"
                htmlType="button"
                disabled={loadingLoginForm.newLoginCodeIsLoading}
                onClick={() => {
                  handleRequestCode(
                    loginFormData.newLogin,
                    loginFormData.newLoginCountryID,
                    (token) => {
                      setLoginFormData({
                        ...loginFormData,
                        newLoginCodeToken: token,
                      });
                    }
                  )
                }}
                size="small"
                style={requestCodeButtonStyle}
              >
                {i18n.t('components.userProfileEditForm.buttons.getCode')}
              </Button>
            </Col>
          </Row>
          <Row gutter={[16, 24]}>
            <Col lg={6}>
              <Button
                type="primary"
                htmlType="button"
                onClick={handleChangeLogin}
                size="small"
                style={buttonStyle}
              >
                {i18n.t('components.userProfileEditForm.buttons.changeLogin')}
              </Button>
            </Col>
          </Row>
        </>
      ) : null}
    </Spin>
  );
}
